import React from 'react';
import {
  Container, Row, Card, CardBody, Table
} from 'reactstrap';
import 'react-slide-out/lib/index.css';
import * as env from "../../../../env";
import { columnHeader } from "./config";
import Pagination from "../../../../shared/components/pagination/Pagination";
import client from "../../../../shared/api-client";

class ProxyLocations extends React.Component {
  state = {
    title: 'Locations',
    addTitle: 'Add Location',
    isOpen: false,
    results : [],
    filteredResults : [],
    columnHeader: columnHeader,
    filters: [],
    filterValues : {
      type: []
    },
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE
  };

  getResults() {
    client(`subnets.php`).then(
      (subnets) => {
        let locations = [];
        subnets.forEach((subnet) => {
          let location = locations.filter(
            (obj) => obj.location === subnet.geo_maxmind
          );
    
          if (location.length === 0) {
            locations.push({
              location: subnet.geo_maxmind,
            });
          }

          locations.map(obj => {
            if (obj.location === subnet.geo_maxmind) {
              if (typeof obj.subnets === 'undefined') {
                obj.subnets = [];
              }
              obj.subnets.push(subnet.subnet);
            }

            return obj;
          });
          
        });
  
        locations.sort(function(a, b) {
          var x = a["location"];
          var y = b["location"];
          return x < y ? -1 : x > y ? 1 : 0;
        });

        this.setResults(locations);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  setResults = (results) => {
    this.setState({
      isOpen: false,
      results : results,
      filteredResults: results
    });
  }

  componentDidMount() {
    this.getResults();
  }

  formChangeHandler = (event) => {
    let filters = this.state.filters;
    let filter = {'name' : event.target.name, 'value' : event.target.value};

    var foundIndex = filters.findIndex(x => x.name === filter.name);

    if (foundIndex >= 0) {
      filters[foundIndex] = filter;
    } else {
      filters.push(filter);
    }

    this.setState({filters});
    this.filterResults();
  }

  filterResults = () => {
    let filteredResults = this.state.results;

    this.state.filters.forEach((element, index) => {
      if (element.value.trim() !== '') {
        switch (element.name) {
          // case 'subnets':
          //   filteredResults = filteredResults.filter(o =>
          //       Object.keys(o).includes(element.value)
          //     );
          //     break;
          default:
            filteredResults = filteredResults.filter(o =>
              Object.keys(o).some(k => o[element.name].toLowerCase().includes(element.value.toLowerCase()))
            );        
        } 
      }
    });
  
    
    this.setState({filteredResults});
  }

  printFilters = () => {
    return (<tr >
      {this.state.columnHeader.map(data => (data.filter) ? (<th key={data.key} > {this.printFilterInput(data)}</th>): <th></th>)}
    </tr>);
  }

  printFilterInput = (input) => {
    if (input.type === 'text')
        return (<input name={input.key} type="text" onChange={this.formChangeHandler}></input>);
    else if (input.type === 'list' || input.type === 'multiple-list')
        return (<select name={input.key} type="text" onChange={this.formChangeHandler}>
          <option value="">All</option>
          {this.printOptions(input.key)}
        </select>);
  }

  printOptions = (key) => {

    return <React.Fragment>
      {this.state.filterValues[key].map(value => ( <option value={value}>{value}</option> ))}
      
    </React.Fragment>
  };

  printRecords = () => {
    let items = this.state.filteredResults.slice(this.state.startIndex, this.state.endIndex + 1);

    return (<React.Fragment>
      {items.map(data => (
        <tr key={data.id}>
          <td>{data.location}</td>
          <td><span className="w3-badge w3-info">{data.subnets.length}</span> {data.subnets.map(subnet => <span className="w3-badge">{subnet}</span>)}</td>
        </tr>
      ))}
    </React.Fragment>
  );
}

usersListingUrl = (location) => {
  return `/proxy/locations/users/${location.id}`
}

pagination = () => {
  return this.state.filteredResults.length > env.RECORDS_PER_PAGE ? (
    <div className="audit-trail-footer">
      <Pagination
        items={this.state.filteredResults}
        onChangePage={(pagination) => this.setState(pagination)}
        pageSize={env.RECORDS_PER_PAGE}
      />
    </div>
  ) : (
    ""
  )
}

toggleAddNew = () => {
  this.setState(prevState => ({ isOpen: !prevState.isOpen }));
}

toggleEdit = (item) => {
  this.setState(prevState => ({ isOpen: !prevState.isOpen}));
}

printActions = () => {
  return <React.Fragment>
    
  </React.Fragment>
}

  render() {
    return (
      <Container>
        <Row className="user-section">
          <Card className="table-section form">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">{this.state.title}</h5>
                <div className="toolbar-buttons">
                  {this.printActions()}
                </div>
              </div>
              <Table responsive hover className="table--head-accent table--bordered">
                <thead>
                  <tr>
                    {this.state.columnHeader.map(data => (<th key={data.key}>{data.name}</th>))}
                  </tr>
                  {this.printFilters()}
                </thead>
                <tbody >
                  {this.printRecords()}
                </tbody>
              </Table>
              {this.pagination()}
            </CardBody>
          </Card>
        </Row>
      </Container>
    );
  }
}

export default ProxyLocations;